import styled from "styled-components";

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
`;
export const StyledIconWrap = styled.span`
  margin-right: ${({ theme }) => theme.space[2]};
`;
